(() => {
jQuery(window).on('elementor/frontend/init', (e)=>{
    elementorFrontend.hooks.addAction('frontend/element_ready/onereach-reports-section.default', ($element)=>{
        $element.find('.onereach-reports-section__navigation a').on('click', function(e) {
            jQuery(this).addClass('active').siblings().removeClass('active');
            const target = jQuery(this).attr('href');
            jQuery('.topbanner-nav-js').removeClass('active');
            jQuery(target).addClass('active');
            return false;
        });
    });
});

})();
//# sourceMappingURL=elementor-onereach-reports.js.map
